

import {
  Modal, List, Row, Col, Button, Alert, Input,
} from 'ant-design-vue';
import notification from 'ant-design-vue/lib/notification';
import dayjs from 'dayjs';
import { defineComponent, PropType } from 'vue';
import { mapGetters, useStore } from 'vuex';
import { surveyMetadataProps } from '../../utils/request';

export interface surveyMetadataMonthProps extends surveyMetadataProps {
  surveyMonthName: string;
}

const Stage = {
  CONFIRM_SURVEYS: 'confirmSurveys',
  STUDY_DETAILS: 'studyDetails',
  COLLABORATORS: 'collaborators',
};
const emptyCollaborator = {
  fullName: '',
  email: '',
};
export default defineComponent({
  name: 'RequestRawDataModal',
  setup() {
    const store = useStore();
    store.dispatch('surveyList/updateSurveys');
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      Stage,
      currentStage: Stage.CONFIRM_SURVEYS,
      researchTitle: '',
      researchDescription: '',
      collaborators: [
        { ...emptyCollaborator },
      ],
    };
  },
  methods: {
    showRequestRawDataModal() {
      this.visible = true;
    },
    handleSignIn() {
      this.$router.push({ name: 'Login', query: { rawDataRequest: this.selectedSurveys.join() } });
      this.visible = false;
    },
    handleSignUp() {
      this.$router.push({ name: 'SignUp', query: { rawDataRequest: this.selectedSurveys.join() } });
      this.visible = false;
    },
    handleClose() {
      this.visible = false;
      this.currentStage = Stage.CONFIRM_SURVEYS;
      this.researchTitle = '';
      this.researchDescription = '';
      this.collaborators = [
        { ...emptyCollaborator },
      ];
    },
    handleContinue() {
      if (this.currentStage === Stage.CONFIRM_SURVEYS) this.currentStage = Stage.STUDY_DETAILS;
      else if (this.currentStage === Stage.STUDY_DETAILS) this.currentStage = Stage.COLLABORATORS;
    },
    handleBack() {
      if (this.currentStage === Stage.STUDY_DETAILS) this.currentStage = Stage.CONFIRM_SURVEYS;
      if (this.currentStage === Stage.COLLABORATORS) this.currentStage = Stage.STUDY_DETAILS;
    },
    async handleSubmitRequest() {
      try {
        // eslint-disable-next-line
        const emailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
        if (!this.collaborators.every((item) => (!item.email || emailRegex.test(item.email)))) {
          notification.error({
            message: 'Please enter a valid email',
          });
          return;
        }
        if (this.collaborators.filter((item) => (!item.fullName && item.email)).length !== 0) {
          notification.error({
            message: 'Please enter a name for the email',
          });
          return;
        }
        if (this.collaborators.filter((item) => (item.fullName && !item.email)).length !== 0) {
          notification.error({
            message: 'Please enter an email for the name',
          });
          return;
        }
        const response = await this.$store.dispatch('rawDataRequests/createRawDataRequest', {
          surveyIds: this.selectedSurveys,
          title: this.researchTitle,
          description: this.researchDescription,
          collaborators: this.collaborators.filter((item) => item.fullName && item.email),
        });
        if (response?.status === 200) {
          notification.success({
            message: 'Your request has been sent successfully',
          });
          this.handleClose();
          return;
        }
        notification.error({
          message: 'Something has gone wrong!',
        });
      } catch (e) {
        notification.error({
          message: 'Something has gone wrong!',
        });
      }
    },
    addCollaborator() {
      this.collaborators.push({ ...emptyCollaborator });
    },
    deleteCollaborator(index: number) {
      this.collaborators.splice(index, 1);
    },
    wordsLimit(value:string) {
      const words = value.split(/[\s]+/);
      const wordLimit = 3000;
      if (words.length >= wordLimit) {
        this.researchDescription = words.slice(0, wordLimit).join(' ');
      }
    },
  },
  computed: {
    ...mapGetters({
      surveyItems: 'surveyList/getSurveys',
      isLogin: 'user/getIsLoggedIn',
    }),
    selectedSurveysDetail() {
      const surveys = this.surveyItems
        .filter((item:surveyMetadataProps) => this.selectedSurveys.map(Number).includes(item.id));
      const result = [] as surveyMetadataMonthProps[];
      surveys.forEach((element:surveyMetadataProps) => {
        result.push({ ...element, surveyMonthName: dayjs().month(element.surveyMonth - 1).format('MMMM') });
      });
      return result;
    },
  },
  components: {
    Modal,
    List,
    Row,
    Col,
    Button,
    Alert,
    Input,
  },
  props: {
    selectedSurveys: {
      type: Array as PropType<Array<string>>,
      default: [] as string[],
    },
    openModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    openModal(val) {
      this.visible = val;
    },
  },
});
